import { Button, Popconfirm, theme } from 'antd';
import { FC } from 'react';
import { ExclamationCircle, Trash } from 'react-bootstrap-icons';
import { useQueryClient } from 'react-query';

import { AppMessage } from '@/common/components';
import { messageOnError } from '@/common/utils';

import { SiteGroupsQueryKeys, useDeleteSiteGroupsMutation } from '@/modules/SiteGroups/queries';

interface Props {
  siteGroupId: string;
  disabled?: boolean;
  handleDeleted?: () => void;
}

export const SiteGroupsDeleteButton: FC<Props> = ({ siteGroupId, disabled, handleDeleted }) => {
  const { token } = theme.useToken();
  const queryClient = useQueryClient();
  const appMessageApi = AppMessage.useControls();

  const { mutate: deleteSiteGroupMutation, isLoading: isDeleteSiteGroupLoading } = useDeleteSiteGroupsMutation(siteGroupId)({
    onSuccess: async () => {
      appMessageApi.success('Групу сайтів успішно видалено!');

      await queryClient.refetchQueries([SiteGroupsQueryKeys.GetAll]);

      handleDeleted?.();
    },
    onError: (error) => {
      messageOnError(error, appMessageApi);
    }
  });

  return (
    <Popconfirm
      disabled={ disabled || isDeleteSiteGroupLoading }
      title="Видалити цю групу сайтів?"
      onConfirm={ () => deleteSiteGroupMutation() }
      okType="danger"
      okText="Так"
      icon={ <ExclamationCircle color={ token.colorError }/> }
      placement="bottomRight"
    >
      <Button loading={ isDeleteSiteGroupLoading } disabled={ disabled } danger icon={ <Trash/> }/>
    </Popconfirm>
  );
};
